import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "../components/shared/layout"
import SEO from "../components/SEO/SEO"
import styled from "@emotion/styled"
import {
  wrapper,
  wrapper1200,
  featuredWrapper,
  noFeaturedWrapper,
  color,
  breakpoints,
  ContentStyles,
  ContentStylesExt,
} from "../utils/style"
import ButtonLink from "../components/shared/ButtonLink"
import Img from "gatsby-image"
import Breadcrumbs from "../components/shared/Breadcrumbs"
import Parallax from "../components/shared/Parallax"

const WrapperDesktop = styled("div")`
  ${wrapper1200};
`

const FeaturedWrapper = styled("div")`
  ${featuredWrapper};
  position: relative;
  max-height: 600px;
  overflow: hidden;
`

const NoFeaturedWrapper = styled("div")`
  ${noFeaturedWrapper};
`

const ContentWrapper = styled("div")`
  ${wrapper};
  ${ContentStyles};
  ${ContentStylesExt};
  padding: 0;
  .prev-next {
    min-height: 70px;
    padding-bottom: 20px;
    display: flex;
    justify-content: center;
  }
  .button {
    margin: 0 16px;
    display: flex;
    align-items: center;
    width: 128px;
  }
`

const Bg = styled("div")`
  border-top: 2px solid ${color.pink};
  padding: 15px 0 5px;
`
const RelatedWrapper = styled("div")`
  padding: 30px 0;
  margin-top: 10px;
  // text-align: center;
  h3 {
    font-size: 1.6rem;
    margin-top: 0;
  }
  ul {
    list-style: none;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
  }
  li {
    width: 48%;
    text-align: left;
    margin-bottom: 20px;
  }
  .text-wrap {
    padding: 16px 0 0;
    .button {
      margin-top: 8px;
    }
  }
  .recent-name {
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
    margin: 0;
  }

  .recent-excerpt {
    font-size: 14px;
    line-height: 20px;
    max-height: 140px;
    overflow-y: hidden;
  }

  @media (max-width: ${breakpoints.md}) {
    ul {
      margin: 10px 0;
    }
    a {
      display: block;
    }
    .text-wrap {
      padding: 16px 0;
    }
  }
  @media (max-width: ${breakpoints.sm}) {
    text-align: left;
    h3 {
      font-size: 18px;
    }
  }
  @media (max-width: ${breakpoints.xs}) {
    li {
      width: 100%;
    }
  }
`

const PostTemplate = ({ data, pageContext }) => {
  const post = data.wordpressPost
  const metaTitle =
    post.yoast_meta && post.yoast_meta.yoast_wpseo_title
      ? post.yoast_meta.yoast_wpseo_title
      : post.title + +"- " + process.env.OWNER
  const metaDesc =
    post.yoast_meta && post.yoast_meta.yoast_wpseo_metadesc
      ? post.yoast_meta.yoast_wpseo_metadesc
      : ""
  const relatedPosts = data.allWordpressPost
  const placeholder = data.placeholder
  const relatedIds = pageContext.related
  const breadcrumbs = pageContext.breadcrumbs
  const page_title = pageContext.page_title
  const prevPost = pageContext.prev
  const nextPost = pageContext.next
  const socialImage = post.featured_media?.localFile?.publicURL

  return (
    <Layout>
      <SEO
        title={metaTitle}
        description={metaDesc}
        pathname={post.path}
        key="seo"
        breadcrumbs={breadcrumbs}
        socialImage={socialImage}
      />
      <Parallax />
      <WrapperDesktop>
        <Breadcrumbs breadcrumbs={breadcrumbs} page_title={page_title} />
        {post.featured_media &&
        post.featured_media.localFile &&
        post.featured_media.localFile.childImageSharp &&
        post.featured_media.localFile.childImageSharp.fluid ? (
          <FeaturedWrapper key="featured-wrapper">
            <Img
              fluid={post.featured_media.localFile.childImageSharp.fluid}
              alt={post.featured_media.alt_text}
            />
            <h1 dangerouslySetInnerHTML={{ __html: post.title }} />
          </FeaturedWrapper>
        ) : (
          <NoFeaturedWrapper key="no-featured-wrapper">
            <h1 dangerouslySetInnerHTML={{ __html: post.title }} />
          </NoFeaturedWrapper>
        )}

        <ContentWrapper key="content-wrapper">
          <div
            key="content"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />
          {(prevPost.slug || nextPost.slug) && (
            <div className="prev-next">
              {prevPost.slug &&
                !prevPost.slug.includes("provider-carousel") && (
                  <ButtonLink
                    className="button transparent-button prev-button"
                    iconName="arrow-left"
                    iconLeft={true}
                    iconColor={color.white}
                    to={prevPost.slug + "/"}
                    text="ก่อนหน้า"
                  />
                )}
              {nextPost.slug &&
                !nextPost.slug.includes("provider-carousel") && (
                  <ButtonLink
                    className="button transparent-button next-button"
                    iconColor={color.white}
                    to={nextPost.slug + "/"}
                    text="ต่อไป"
                  />
                )}
            </div>
          )}
        </ContentWrapper>

        {relatedIds.length > 0 && (
          <Bg key="related-bg">
            <RelatedWrapper>
              <h3 className="h1 rich-design">
                <span>โพสต์อื่นๆ จาก SCR888</span>
              </h3>
              <ul>
                {relatedPosts.edges.map((item, index) => (
                  <li key={item.node.slug + index}>
                    <Link to={"/" + item.node.slug + "/"}>
                      {item.node.featured_media &&
                      item.node.featured_media.localFile &&
                      item.node.featured_media.localFile.childImageSharp ? (
                        <div className="img-wrap">
                          <Img
                            fluid={
                              item.node.featured_media.localFile.childImageSharp
                                .fluid
                            }
                            alt={
                              item.node.featured_media.alt_text
                                ? item.node.featured_media.alt_text
                                : item.node.title
                            }
                          />
                        </div>
                      ) : (
                        <div className="img-wrap">
                          <Img
                            fluid={placeholder.childImageSharp.fluid}
                            alt={item?.node?.label ? item.node.label : "แบนเนอร์ เว็บพนัน"}
                          />
                        </div>
                      )}
                      <div className="text-wrap">
                        <div
                          className="recent-name"
                          dangerouslySetInnerHTML={{ __html: item.node.title }}
                        />
                        <div
                          className="recent-excerpt"
                          dangerouslySetInnerHTML={{
                            __html: item.node.excerpt.slice(0, 250) + "...",
                          }}
                        />
                        <button className="button white-button">
                          อ่านเพิ่มเติม
                        </button>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </RelatedWrapper>
          </Bg>
        )}
      </WrapperDesktop>
    </Layout>
  )
}

export default PostTemplate

export const pageQuery = graphql`
  query($id: String!, $related: [Int]) {
    wordpressPost(id: { eq: $id }) {
      wordpress_id
      title
      content
      path
      date(formatString: "MMMM DD, YYYY")
      yoast_meta {
        yoast_wpseo_title
        yoast_wpseo_metadesc
      }
      featured_media {
        alt_text
        localFile {
          publicURL
          childImageSharp {
            fluid(maxWidth: 1400) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
    allWordpressPost(
      filter: {
        wordpress_id: { in: $related }
        acf: { post_template: { eq: "promotion" } }
      }
      limit: 2
    ) {
      edges {
        node {
          slug
          title
          excerpt
          featured_media {
            alt_text
            localFile {
              childImageSharp {
                fluid(maxWidth: 600) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
    placeholder: file(relativePath: { eq: "placeholder.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 350) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`
